<div class="forgot-hero">
    <div class="forgot-hero__inner">
        <h1 class="forgot-hero__title" [innerText]="scope.getText | transform:'FORGOT_PASSWORD?'"></h1>
    </div>
</div>
<div class="forgot-body">
    <div class="forgot-card">
        <app-error-summary [error]="scope.error" *ngIf="scope.error"></app-error-summary>
        <ng-container *ngIf="!scope.success">
            <p class="forgot-card__desc" [innerText]="scope.getText | transform:'FORGOT_PASSWORD_DESC'"></p>
            <dynamic-form (submit)="scope.submitForm($event)" [groupValidators]="scope.groupValidators"
                [fields]="scope.forgotPasswordConfig" [group]></dynamic-form>
        </ng-container>
        <ng-container *ngIf="scope.success">
            <h2 [innerText]="scope.getText | transform:'SUCCESS'"></h2>
            <p [innerText]="scope.getText | transform:'CHECK_EMAIL_TO_RESET'"></p>
        </ng-container>
    </div>
</div>
